import type { SVGProps } from "react";

/**
 * Minimal line-icon set for the services grid.
 * Single stroke weight, no fills except brand accent dots,
 * so the set reads as one consistent system.
 */

const base: SVGProps<SVGSVGElement> = {
  viewBox: "0 0 40 40",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

export function OutdoorAdvertisingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="5" y="9" width="30" height="15" rx="1.2" />
      <line x1="12" y1="24" x2="10" y2="34" />
      <line x1="28" y1="24" x2="30" y2="34" />
      <line x1="9" y1="28" x2="12" y2="24" />
    </svg>
  );
}

export function HoardingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="4" y="12" width="24" height="13" rx="1" />
      <line x1="9" y1="25" x2="8" y2="33" />
      <line x1="23" y1="25" x2="24" y2="33" />
      <path d="M28 15c4 .6 7 3 7 7s-2.5 7-6 8" />
    </svg>
  );
}

export function BrandingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M8 34V16l12-9 12 9v18" />
      <line x1="14" y1="34" x2="14" y2="22" />
      <line x1="26" y1="34" x2="26" y2="22" />
      <line x1="14" y1="22" x2="26" y2="22" />
    </svg>
  );
}

export function SignageIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="6" y="14" width="24" height="11" rx="2" />
      <circle cx="13" cy="19.5" r="1.6" fill="currentColor" stroke="none" />
      <circle cx="20" cy="19.5" r="1.6" fill="currentColor" stroke="none" />
      <circle cx="27" cy="19.5" r="1.6" fill="currentColor" stroke="none" />
      <line x1="18" y1="25" x2="18" y2="31" />
      <line x1="12" y1="31" x2="24" y2="31" />
    </svg>
  );
}

export function FlexPrintingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="6" y="6" width="19" height="19" rx="1.5" transform="rotate(-6 15.5 15.5)" />
      <path d="M27 12c3.4.8 5.6 3.4 5.6 7s-2 6.5-5.2 7.6" />
    </svg>
  );
}

export function BusinessBrandingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="6" y="6" width="28" height="28" rx="3" />
      <path d="M12 27c3.4-7 6.8-7 9 -3.4 2.6 4.3 5 4.3 8.6-2" />
      <circle cx="12.6" cy="12.6" r="2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function RetailBrandingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <path d="M7 15l1.6-6h22.8L33 15" />
      <path d="M8 15v15a1 1 0 001 1h22a1 1 0 001-1V15" />
      <line x1="8" y1="15" x2="32" y2="15" />
      <line x1="16" y1="31" x2="16" y2="21" />
      <line x1="24" y1="31" x2="24" y2="21" />
      <line x1="16" y1="21" x2="24" y2="21" />
    </svg>
  );
}

export function EventBrandingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...props}>
      <rect x="8" y="8" width="24" height="24" rx="2" />
      <line x1="8" y1="15" x2="32" y2="15" />
      <line x1="14" y1="6" x2="14" y2="10" />
      <line x1="26" y1="6" x2="26" y2="10" />
      <circle cx="20" cy="24" r="4" />
    </svg>
  );
}
